import { useEffect, useRef } from "react";

const scrollingElement = () =>
  document.scrollingElement || document.documentElement;

export const useJourneyScrollRestoration = (active, stepId) => {
  const positions = useRef(new Map());
  const previousStep = useRef(null);

  useEffect(() => {
    if (!active || !stepId) return undefined;
    const scroller = scrollingElement();
    const priorId = previousStep.current;
    if (priorId) positions.current.set(priorId, scroller.scrollTop);
    previousStep.current = stepId;
    const nextTop = positions.current.get(stepId) || 0;
    const frame = window.requestAnimationFrame(() => {
      scroller.scrollTo({ left: 0, top: nextTop });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [active, stepId]);
};
